<template>
  <div class="grey lighten-4 px-2">
    <v-row align="center">
      <v-col md="3" cols="12" class="flex-grow-0">
        <v-autocomplete
          v-model="selected"
          :items="clients"
          label="Search client"
          :search-input.sync="clientSearchQuery"
          item-text="name"
          item-value="slug"
          :loading="clientsLoading"
          no-filter
          hide-no-data
          clearable
          return-object
        >
          <template
            v-slot:append-outer
            v-if="$auth.strategy.name === 'realHrSoft'"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="showFederatedClientSelect = true">
                  <v-icon v-text="$getIcon('mdiDomain')" color="blue"> </v-icon>
                </v-btn>
              </template>
              <span>Select Fedareted Client</span>
            </v-tooltip>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-avatar class="text-h5 font-weight-light white--text">
              <v-img
                contain
                v-if="item.logo"
                :src="item.logo"
                aspect-ratio="1"
              />
              <v-icon v-else v-text="$getIcon('mdiAccountCircle')"></v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="item.name"></v-list-item-title>
              <v-list-item-subtitle v-text="item.email"></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon>mdi-bitcoin</v-icon>
            </v-list-item-action>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" md="6" class="flex-grow-0">
        <div>
          <div class="caption grey--text ml-1">
            Recent Clients
          </div>
          <!--          <div v-if="clientsLoading" class="d-flex">-->
          <!--            <v-skeleton-loader-->
          <!--              v-for="idx in 10"-->
          <!--              type="avatar"-->
          <!--              :key="`recentClientSkeleton-${idx}`"-->
          <!--              class="mx-1"-->
          <!--            ></v-skeleton-loader>-->
          <!--          </div>-->
          <div v-if="recentClients.length === 0">
            You don't have any data on recent clients.
          </div>
          <div v-if="recentClients.length > 0" class="d-inline-flex">
            <div
              v-for="(client, index) in recentClients.slice(0, 10)"
              :key="index"
              class="mx-1"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <a @click="selectedClient = client">
                    <v-avatar tile>
                      <img
                        :src="
                          client.logo
                            ? client.logo
                            : require(`@/static/images/organization/default-logo.jpg`)
                        "
                        style="border: 2px solid #efefef;"
                        v-on="on"
                      />
                    </v-avatar>
                  </a>
                </template>
                <span>
                  {{ client.name }}
                </span>
              </v-tooltip>
            </div>
          </div>
        </div>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" md="2" class="align-center flex-grow-0 pr-5">
        <v-btn @click="showClientForm = true" outlined color="blue">{{
          selectedClient ? "Update Client" : "Add Client"
        }}</v-btn>
      </v-col>
    </v-row>
    <div>
      <v-navigation-drawer
        width="900"
        v-model="showClientForm"
        right
        temporary
        fixed
        clipped
      >
        <template v-slot:prepend>
          <v-card tile>
            <vue-card-title
              :title="clientFormTitle"
              dark
              :subtitle="'Fill up the following form to action on client data.'"
              :icon="$getIcon('mdiFileDocumentEdit')"
              closable
              @close="showClientForm = false"
            >
            </vue-card-title>
            <v-divider></v-divider>
          </v-card>
        </template>
        <client-form
          v-if="showClientForm"
          :action-data="selectedClient ? selectedClient : undefined"
          :clientType="selectedClient ? selectedClient.client_type : undefined"
          @close="showClientForm = false"
          @clientFormResponse="formSuccess($event)"
        >
        </client-form>
      </v-navigation-drawer>
    </div>
    <div>
      <v-dialog
        v-model="showFederatedClientSelect"
        persistent
        scrollable
        width="400"
      >
        <v-card tile>
          <vue-card-title
            title="Select fedarated client"
            :subtitle="'Select client from sister companies.'"
            :icon="$getIcon('mdiFileDocumentEdit')"
            closable
            @close="showFederatedClientSelect = false"
          >
          </vue-card-title>
          <v-divider></v-divider>
          <v-card-text class="form-scroll scrollbar">
            <foreign-client-form
              @clientData="setResolvedClient"
            ></foreign-client-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import ClientForm from "@/components/crm/client/forms/ClientForm";
import ForeignClientForm from "@/components/crm/client/forms/ForeignClientForm";
import { mdiPlus, mdiUpdate } from "@mdi/js";
import cancelRequestMixin from "@/mixins/cancelRequestMixin";
export default {
  icons: {
    mdiPlus,
    mdiUpdate
  },
  mixins: [cancelRequestMixin],
  props: {
    client: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      clientSearchQuery: "",
      selected: undefined,
      selectedClient: undefined,
      clients: [],
      recentClients: [],
      clientsLoading: false,
      showClientForm: false,
      showFederatedClientSelect: false
    };
  },
  components: {
    ClientForm,
    ForeignClientForm
  },
  watch: {
    selected: function(newVal) {
      console.log(newVal);
      this.getSelectedClients(newVal.slug);
    },
    selectedClient: function(newVal) {
      this.$emit("update:client", newVal);
    },
    client: function(newVal) {
      this.selectedClient = newVal;
    },
    clientSearchQuery: function(newVal) {
      if (newVal?.length > 1) {
        this.getClients();
      }
    }
  },
  mounted() {
    this.getRecentClient();
  },
  methods: {
    getSelectedClients(slug) {
      this.$axios.get(`/api/v1/crm/clients/${slug}/`).then(({ data }) => {
        this.selectedClient = data;
      });
    },
    getRecentClient() {
      this.$axios
        .get(
          `/api/v1/crm/clients/recent/?organization__slug=${this.$store.state.shell.currentOrganizationId}`
        )
        .then(response => {
          this.recentClients = response.data;
        });
    },
    getClients() {
      this.clientsLoading = true;
      this.checkRequest();
      this.$axios
        .get(
          `/api/v1/crm/clients/select/?organization__slug=${this.$store.state.shell.currentOrganizationId}`,
          {
            params: {
              search: this.clientSearchQuery
            },
            cancelToken: this.axiosSource.token
          }
        )
        .then(({ data }) => {
          this.clearOldRequest("Success");
          this.clients = data;
          this.clientsLoading = false;
        });
    },
    formSuccess(event) {
      this.$store.dispatch("shell/showSnackbar", {
        text: `Success`,
        color: "green"
      });
      this.getClients();
      this.getSelectedClients(event.slug);
      this.getRecentClient();
      this.$emit("updateData");
    },
    setResolvedClient(clientData) {
      let matchedClient = this.clients.find(obj => {
        return clientData.id === obj.id;
      });

      if (!matchedClient) {
        this.clients.push(clientData);
      }
      this.selectedClient = clientData;
      this.showFederatedClientSelect = false;
    }
  },
  computed: {
    clientFormTitle() {
      let action = this.selectedClient ? "Update" : "Create";
      return `${action} Client`;
    }
  }
};
</script>
